var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyHuf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_136712)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1516_136712)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8.00391,
    width: 46.1221,
    height: 30.6785,
    rx: 5.76455,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.00391 0H38.1182V30.6785H-8.00391",
    fill: "#477050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.00391 0H38.1182V20.4523H-8.00391",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.00391 0H38.1182V10.2262H-8.00391",
    fill: "#CE2939"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#E5E5E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_136712"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1516_136712"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8.00391,
    width: 46.1221,
    height: 30.6785,
    rx: 5.76455,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyHuf);
export default __webpack_public_path__ + "static/media/Currency=HUF.660a2cb901ebc10cb3b633e4b86d5102.svg";
export { ForwardRef as ReactComponent };